import useTranslator from "../../hooks/useTranslator";
import styles from "./ProfileCompletionPercentage.module.css";

const ProfileCompletionPercentage = ({
  percent = 0,
  loading = false,
  missingDocs = [],
  requiredDocs = [],
}) => {
  const { _t } = useTranslator();
  const numericPercent = Number(percent);
  const completionPercent = Number.isFinite(numericPercent)
    ? Math.min(100, Math.max(0, numericPercent))
    : 0;
  const dashOffset = 251 - (251 * completionPercent) / 100;

  return (
    <div
      className={styles.wrap}
      role={loading ? "status" : "progressbar"}
      aria-live={loading ? "polite" : undefined}
      aria-label={_t("profileCompletion", "Profile completion")}
      aria-valuemin={loading ? undefined : 0}
      aria-valuemax={loading ? undefined : 100}
      aria-valuenow={loading ? undefined : completionPercent}
    >
      <div className={`${styles.circle} ${loading ? styles.loading : ""}`}>
        <svg width="90" height="90" viewBox="0 0 90 90" aria-hidden="true">
          <circle
            cx="45"
            cy="45"
            r="40"
            style={{ stroke: "var(--overlay-light)" }}
            strokeWidth="8"
            fill="none"
          />
          <circle
            className={styles.progress}
            cx="45"
            cy="45"
            r="40"
            style={{ stroke: "var(--lime)" }}
            strokeWidth="8"
            fill="none"
            strokeDasharray={251}
            strokeDashoffset={loading ? 188 : dashOffset}
            strokeLinecap="round"
          />
        </svg>
        <span className={styles.value}>
          {loading ? (
            <span className={styles.loadingDots} aria-hidden="true">
              <i />
              <i />
              <i />
            </span>
          ) : (
            `${completionPercent}%`
          )}
        </span>
      </div>
      <div className={styles.label}>
        {loading
          ? _t("calculating", "Calculating")
          : _t("complete", "Complete")}
      </div>
    </div>
  );
};

export default ProfileCompletionPercentage;
